export default function GallerySection() {
  const galleryImages = [
    {
      src: 'https://funaffairs.com/wp-content/uploads/2022/11/balloon-2.png',
      alt: 'Inflatable Bounce House Rental',
      category: 'Bounce Houses'
    },
    {
      src: 'https://funaffairs.com/wp-content/uploads/2022/11/balloon-1.png',
      alt: 'Interactive Group Activities',
      category: 'Interactive Games'
    },
    {
      src: 'https://funaffairs.com/wp-content/uploads/2022/11/balloon-3.png',
      alt: 'Entertainment Services',
      category: 'Entertainment'
    },
    {
      src: 'https://funaffairs.com/wp-content/uploads/2022/11/fun-affairs.png',
      alt: 'Party Games and Activities',
      category: 'Party Games'
    },
    {
      src: 'https://funaffairs.com/wp-content/uploads/2022/11/balloon-2.png',
      alt: 'Fun Foods Equipment',
      category: 'Fun Foods'
    },
    {
      src: 'https://funaffairs.com/wp-content/uploads/2022/11/balloon-1.png',
      alt: 'Photo Program Services',
      category: 'Photo Programs'
    }
  ];

  return (
    <section className="py-24 bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl sm:text-5xl font-bold text-gray-900 mb-4" style={{ fontFamily: 'Sora, sans-serif' }}>
            See Our Equipment in Action
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Browse our gallery of successful events and see the quality equipment and professional service that makes Fun Affairs the top choice in the Lehigh Valley.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {galleryImages.map((image, index) => (
            <div 
              key={index}
              className="group relative overflow-hidden rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-300 aspect-square"
            >
              <img 
                src={image.src}
                alt={image.alt}
                className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-300"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                <div className="absolute bottom-0 left-0 right-0 p-6">
                  <p className="text-white font-bold text-lg">{image.category}</p>
                  <p className="text-white/90 text-sm">{image.alt}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}